import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string, number } = proptypes;
import { ProductListContext } from '../ProductListContext';

// SUI tertiary button style matching desktop-mock.png - using direct Tailwind classes
const buttonClassName = [
  // Base button layout
  'sui-inline-flex',
  'sui-items-center',
  'sui-justify-center',
  // Typography
  'sui-font-regular',
  'sui-text-base',
  'sui-leading-tight',
  'sui-text-subtle',
  // Sizing & spacing
  'sui-px-3',
  'sui-py-1',
  // Appearance
  'sui-rounded-base',
  'sui-cursor-pointer',
  'sui-transition-colors',
  // Tertiary variant styles (gray border, transparent bg)
  'sui-rounded-lg',
  'sui-border-1',
  'sui-border-button-medium',
  'sui-border-button-focus',
  'sui-border-button-hover',
  // 'sui-bg-transparent',
  // 'sui-border-1',
  'sui-border-solid',
  // 'sui-border-inherit',
  // 'sui-outline-inherit',
  // 'sui-text-primary',
  // Hover state
  'hover:sui-bg-button-hover'
].join(' ');

export const ReplaceButton = ({
  itemId, intentId, groupId, intent, quantity
}) => {
  const { setReplaceMode, isReplaceMode, replacingItemId } = useContext(ProductListContext);

  const handleReplace = () => {
    if (setReplaceMode) {
      setReplaceMode({
        itemId,
        intentId,
        groupId,
        intent,
        quantity
      });
    }
  };

  // Don't render if we're already in replace mode for this item
  if (isReplaceMode && replacingItemId === itemId) {
    return null;
  }

  return (
    <button
      type="button"
      className={buttonClassName}
      onClick={handleReplace}
      aria-label="Replace Item"
      data-testid="replace-button"
    >
      Replace
    </button>
  );
};

ReplaceButton.propTypes = {
  itemId: string.isRequired,
  intentId: string,
  groupId: string,
  intent: string,
  quantity: number
};

ReplaceButton.defaultProps = {
  intentId: null,
  groupId: null,
  intent: '',
  quantity: 1
};
